<template>
    <v-card class="ma-auto px-12 py-6">
        <v-card-title class="justify-center title">What would you like to do next?</v-card-title>
        <v-card-text>
            <div class="d-flex justify-center">
                <v-btn
                    :to="{
                        name: 'snapshot-applications-add',
                        params: {
                            oid: $route.params.oid,
                            sid: $route.params.sid,
                            iid: $route.params.iid,
                            snid: $route.params.snid
                        }
                    }"
                    color="primary"
                    class="mr-3">
                    Add Applications
                </v-btn>
                <v-btn
                    v-if="applications.length"
                    :to="{
                        name: 'app-open',
                        params: {
                            oid: $route.params.oid,
                            sid: $route.params.sid,
                            iid: $route.params.iid,
                            snid: $route.params.snid,
                            aid: applications[0].aid
                        }
                    }"
                    color="primary"
                    class="mr-3"
                    outlined
                    text>
                    Launch the Application
                </v-btn>
                <v-btn
                    :to="{
                        name: 'snapshot-files',
                        params: {
                            oid: $route.params.oid,
                            sid: $route.params.sid,
                            iid: $route.params.iid,
                            snid: $route.params.snid,
                            localPath: currentFileLocalPath,
                            fileArea: fileAreaType
                        }
                    }"
                    color="primary"
                    outlined
                    text
                    class="mr-3">
                    Add Files
                </v-btn>
                <v-btn
                    :to="{
                        name: 'config-space-users',
                        params: { oid: $route.params.oid, sid: $route.params.sid }
                    }"
                    color="primary"
                    outlined
                    text
                    class="mr-3">
                    Invite Users
                </v-btn>
                <v-btn
                    :to="{
                        name: 'snapshot-overview',
                        params: { oid: $route.params.oid, sid: $route.params.sid, iid: $route.params.iid, snid: $route.params.snid }
                    }"
                    color="primary"
                    outlined
                    text>
                    Go to Space Overview
                </v-btn>
            </div>
        </v-card-text>
        <v-card-actions class="justify-center">
            <v-btn :to="{ name: 'home-dashboard', params: { oid: $route.params.oid } }" text>Return to Dashboard</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapState('snapshotStore', ['applications', 'fileAreaType']),
        ...mapGetters('snapshotStore', ['currentFileLocalPath'])
    }
}
</script>
